import { render } from "./ElegirFormaDePago.vue?vue&type=template&id=370b3e57"
import script from "./ElegirFormaDePago.vue?vue&type=script&lang=js"
export * from "./ElegirFormaDePago.vue?vue&type=script&lang=js"

import "./ElegirFormaDePago.vue?vue&type=style&index=0&id=370b3e57&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__